import React from 'react';
import { ProductCard } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import { useDietaryRestrictions } from '../../../../components/DietaryRestrictions';
import type { PartialOrderConflict } from '../../../../graphql/partials';
import { ConflictType } from '../../../../graphql/types';

type ConflictCardProps = { readonly conflict: PartialOrderConflict };
export const ConflictCard = ({ conflict }: ConflictCardProps) => {
  const { t, formatPrice, formatNumber } = useLocalizationContext();
  const getRestrictionNotice = useDietaryRestrictions();

  const unavailableNotice = [
    ConflictType.DeliveryIneligible,
    ConflictType.ProductUnavailable,
  ].includes(conflict.type)
    ? t('reorder.conflicts.product-unavailable')
    : t('reorder.conflicts.ingredients-unavailable', {
        ingredients: conflict.unavailableIngredients
          .map((ingredient) => ingredient.name)
          .join(', '),
      });

  return (
    <ProductCard
      key={conflict.product.id}
      restrictionNotice={getRestrictionNotice(
        conflict.product.dietaryProperties,
      )}
      unavailableNotice={
        conflict.type === ConflictType.NoConflict
          ? undefined
          : unavailableNotice
      }
      name={conflict.product.name ?? ''}
      description={conflict.product.description}
      label={conflict.product.label?.name}
      price={formatPrice(conflict.product.cost ?? 0, 'USD')}
      calories={`${formatNumber(conflict.product.calories ?? 0)} cal`}
      cloudinaryImageSrc={conflict.product.asset?.url ?? ''}
    />
  );
};
